<template>
    <div>{{ text }}</div>
</template>


<script>
export default {
    name: "get-survey-action-result",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    computed: {
        text() {
            return this.action.surveyId === "" ? "..." : this.action.surveyId;
        },
    },
};
</script>